var map = {
	"./中国具身智能创新.png": "22f4",
	"./十大创新奖.png": "a0c0",
	"./年度最佳Ai手机智能助手.png": "5b4d",
	"./年度最佳Ai笔记本.png": "74f8",
	"./年度最佳MPV.png": "2755",
	"./年度最佳SUV.png": "6652",
	"./年度最佳冰箱.png": "ba36",
	"./年度最佳净水机.png": "0ce9",
	"./年度最佳创新家电.png": "d6d7",
	"./年度最佳创新硬件.png": "07fb",
	"./年度最佳国产AI智能助手.png": "976a",
	"./年度最佳平板电脑.png": "51f8",
	"./年度最佳影像手机.png": "8e06",
	"./年度最佳性能笔记本.png": "8743",
	"./年度最佳扫地机器人.png": "ccc6",
	"./年度最佳折叠屏手机.png": "3a11",
	"./年度最佳教育硬件.png": "a32f",
	"./年度最佳新出行.png": "0ed3",
	"./年度最佳旗舰手机.png": "4f59",
	"./年度最佳智能手表.png": "3de3",
	"./年度最佳智能眼镜.png": "f89c",
	"./年度最佳智驾系统.png": "19e6",
	"./年度最佳洗地机.png": "7a93",
	"./年度最佳洗碗机.png": "ccde",
	"./年度最佳洗衣机.png": "c6ca",
	"./年度最佳烟机灶具.png": "b120",
	"./年度最佳热水器.png": "e5c6",
	"./年度最佳电竞手机.png": "fe32",
	"./年度最佳电视.png": "097e",
	"./年度最佳相机.png": "f30d",
	"./年度最佳空调.png": "4af9",
	"./年度最佳耳机.png": "3ebc",
	"./年度最佳蒸烤一体机.png": "fd5d",
	"./年度最佳路由器.png": "418a",
	"./年度最佳轿车.png": "0fb1",
	"./最具潜力新能源车.png": "2821",
	"./最受欢迎新能源车.png": "46d9",
	"./极果出品.png": "04aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a95";